import { render, staticRenderFns } from "./SectionTextIcons.vue?vue&type=template&id=079bdd14&scoped=true&"
import script from "./SectionTextIcons.vue?vue&type=script&lang=js&"
export * from "./SectionTextIcons.vue?vue&type=script&lang=js&"
import style0 from "./SectionTextIcons.vue?vue&type=style&index=0&id=079bdd14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079bdd14",
  null
  
)

export default component.exports